import React from "react";
import clsx from "clsx";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import PercentageInput from "../../PercentageInput/PercentageInput";
import CurrencyInput from "../../CurrencyInput/CurrencyInput";
import DatePickerInput from "../../DatePickerInput/DatePickerInput";
import DateHelper from "../../DateHelper/DateHelper";
import AutoPriceRuleBuilderErrors from "../AutoPriceRuleBuilderErrors";
import I18n from "i18n-js";
import numeral from "numeral";
import { ru } from "date-fns/locale";

class AutoPriceRuleBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.activeTab == "general",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        {this.renderGeneralForm()}
      </div>
    );
  }

  renderErrors() {
    var errors = AutoPriceRuleBuilderErrors.generalErrors(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var generalErrors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{generalErrors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field) {
    var classname = "form-control";

    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }

    return classname;
  }


  renderGeneralForm() {
    const pace_array = this.props.pace_array
    const occupancy_array = this.props.occupancy_array

    this.props.auto_price_rules_for_date_range.map((rule) => {
      pace_array.map((pace) => {
        if(rule.pace_selector == pace.pace_selector) {
          pace_array.splice(pace_array.indexOf(pace), 1)
          pace.id = rule.id
          pace_array.push(pace)
        }
      })
    })

    this.props.auto_price_rules_for_date_range.map((rule) => {
      occupancy_array.map((occupancy) => {
        if(rule.order == occupancy.order) {
          occupancy_array.splice(occupancy_array.indexOf(occupancy), 1)
          occupancy.id = rule.id
          occupancy.occupancy_percentage = rule.occupancy_percentage
          occupancy_array.push(occupancy)
        }
      })
    })

    pace_array.sort((a, b) => a.order - b.order)
    occupancy_array.sort((a, b) => a.order - b.order)

    return (
      <div>
        {/* Code, Name and Status */}
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t("code")}*`}</label>
              <input
                id="code"
                type="text"
                name="code"
                maxLength="12"
                className={this.renderFieldClasses("code")}
                value={this.props.code || ""}
                onChange={this.props.onChange}
              />
              {this.renderFieldErrors("code")}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t("name")}*`}</label>
              <input
                id="name"
                type="text"
                name="name"
                className={this.renderFieldClasses("name")}
                value={this.props.name || ""}
                onChange={this.props.onChange}
              />
              {this.renderFieldErrors("name")}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("status")}*</label>
              <br />
              <select
                id="status"
                name="status"
                value={this.props.status || ""}
                onChange={this.props.onChange}
                className={this.renderFieldClasses("status")}
              >
                <option value="enabled">{I18n.t("enabled")}</option>
                <option value="disabled">{I18n.t("disabled")}</option>
              </select>
              {this.renderFieldErrors("status")}
            </div>
          </div>
        </div>

        <br />

        {/* Start Date, End Date, Begin Days Out, End Days Out */}
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("begins")}* <span className="ss-help help" title={I18n.t('dynamic_rate_begin_date_helper_text')}></span></label>
              <DatePickerInput
                selectedDate={this.props.start_date || ""}
                dateFormat={DateHelper.rubyToDateFNS(this.props.date_format)}
                classNames={this.renderFieldClasses("start_date")}
                onChange={this.onChangeStartDate}
              />
              {this.renderFieldErrors("start_date")}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("ends")}* <span className="ss-help help" title={I18n.t('dynamic_rate_end_date_helper_text')}></span></label>
              <DatePickerInput
                selectedDate={this.props.end_date || ""}
                dateFormat={DateHelper.rubyToDateFNS(this.props.date_format)}
                classNames={this.renderFieldClasses("end_date")}
                onChange={this.onChangeEndDate}
              />
              {this.renderFieldErrors("end_date")}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("begin_days_out")}* <span className="ss-help help" title={I18n.t('dynamic_rate_begin_days_out_helper_text')}></span></label>
              <br />
              <NumberSpinner
                name="begin_days_out"
                value={this.props.begin_days_out}
                onChange={this.props.onChange}
                min={0}
                max={365}
                className={this.renderFieldClasses("begin_days_out")}
              />
              {this.renderFieldErrors("begin_days_out")}
            </div>
          </div> 

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("end_days_out")}* <span className="ss-help help" title={I18n.t('dynamic_rate_end_days_out_helper_text')}></span></label>
              <br />
              <NumberSpinner
                name="end_days_out"
                value={this.props.end_days_out}
                onChange={this.props.onChange}
                min={1}
                max={365}
                className={this.renderFieldClasses("end_days_out")}
              />
              {this.renderFieldErrors("end_days_out")}
            </div>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('applied_to')}* <span className="ss-help help" title={I18n.t('dynamic_rate_applied_to_helper_text')}></span></label>
              <br />
              <select
                id="property_wide"
                name="property_wide"
                value={this.props.property_wide}
                onChange={this.props.onChange}
                className={this.renderFieldClasses('status')} >
                <option value="room_type">{I18n.t('room_type')}</option>
                <option value="property">{I18n.t('property')}</option>
              </select>
            </div>
          </div>
        </div>
        <br />
            
        {this.props.price_type == "pace" 
          ?
            this.renderAmountorPercentageForPace(pace_array)
          :
            this.renderAmountorPercentageForOccupancy(occupancy_array)
        }
      </div>
    )
  }

  renderAmountorPercentageForPace(pace_array) { 
    var paces = pace_array.map((pace, idx) => {
      var amount = null 
      var percentage = null
      var room_types = []
      var auto_price_rates = []
      var order = null

      this.props.auto_price_rules_for_date_range.forEach((rule) => {
        if(rule.pace_selector == pace.pace_selector) {
          amount = rule.amount
          percentage = rule.percentage
          room_types = rule.room_types
          auto_price_rates = rule.auto_price_rates
          order = rule.order
        }
      })

      return (
        <div className="col-sm-3" key={idx} >
          <div className="panel panel-default" style={{ marginBottom: 0 }}>
            <div className="panel-body container" style={this.props.selected[0] == pace.id && this.props.selected[1] == true  ? {border: "1px solid #E3E3E4", borderColor: "#343a40"} : {backgroundColor: "#eee"}}>
              <div className="row" style={{display: "flex", justifyContent: "flex-end", margin: "5px"}}>
              <div className="col-md-6" style={{marginRight: "auto"}}>
                <label>{I18n.t("last_year")}</label>
              </div>
                {this.props.selected[0] == pace.id && this.props.selected[1] == true  
                  ?  null
                  :  <button type="button" className="no-ladda btn btn-primary btn-sm" onClick={(e) => this.props.onClickPace(e, pace)}>{I18n.t('edit')}</button>
                }    
              </div>
              <hr />
              <span>
                <div style={{width: '20px', height: '20px', display: 'inline-block', backgroundColor: pace.color, position: 'relative', top: '5px'}}></div>
                {`  ${I18n.t(pace.pace_selector)} ${pace.percentage}`}
                <span></span>
              </span>
              <div className="row" style={{paddingTop: '10px'}}>
                <div className="col-md-5">
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label>{I18n.t('amount')} <span className="ss-help help" title={I18n.t('rate_amount_helper_text')}></span></label>
                    {this.props.selected[0] == pace.id && this.props.selected[1] == true  
                      ?  <CurrencyInput name="amount" onChange={(e) => this.props.onChangeAmount(e, pace)} value={amount} className={this.renderFieldClasses('amount')} ignoreComponentWillReceiveProps={true}  />
                      :  <div>{amount ? this.formatCurrency(amount) : null}</div>
                    }
                    {this.renderFieldErrors('amount')}
                  </div>
                </div>
                <div className="col-md-2 or-col">
                  <div className="input-group input-group-currency maxlength7">{I18n.t('or')}</div>
                </div>
                <div className="col-md-5">
                  <div className="form-group percentage-form-group">
                    <label>{I18n.t('percentage')} <span className="ss-help help" title={I18n.t('rate_percentage_helper_text')}></span></label>
                    {this.props.selected[0] == pace.id && this.props.selected[1] == true  
                      ?  <PercentageInput name="percentage" onChange={(e) => this.props.onChangePercentage(e, pace)} value={percentage} className={this.renderFieldClasses('percentage')} />
                      :  <div>{percentage ? this.formatPercentage(percentage) : null}</div>
                    }
                    {this.renderFieldErrors('percentage')}
                  </div>
                </div>
              </div>
              {this.renderRoomTypes(room_types, this.props.selected[0] == pace.id && this.props.selected[1] == true)}
              {this.renderRates(auto_price_rates, this.props.selected[0] == pace.id && this.props.selected[1] == true)}
              {this.props.selected[0] == pace.id && this.props.selected[1] == true
                ? this.renderClearButton(pace)
                : null
              }
            
            </div>
          </div>
        </div>    
      ) 
    }) 
    return (
      <div className= "row">
        {paces}
      </div>
    )  
  }

  renderAmountorPercentageForOccupancy(occupancy_array) {

    var occupancies = occupancy_array.map((occupancy, idx) => {
      var amount = null
      var percentage = null
      var room_types = []
      var auto_price_rates = []
      var occupancy_comparator = null
      var occupancy_percentage = null
      var order = null

      this.props.auto_price_rules_for_date_range.forEach((rule) => {
        if (rule.occupancy_percentage == occupancy.occupancy_percentage) {
          amount = rule.amount
          percentage = rule.percentage
          room_types = rule.room_types
          auto_price_rates = rule.auto_price_rates
          occupancy_comparator = rule.occupancy_comparator
          occupancy_percentage = rule.occupancy_percentage
          order = rule.order
        }
      })
      return (
        <div className="col-sm-3" key={idx} >
          <div className="panel panel-default" style={{ marginBottom: 0 }}>
            <div className="panel-body container" style={this.props.selected[0] === occupancy.id && this.props.selected[1] === true  ? {border: "1px solid #E3E3E4", borderColor: "#343a40"} : {backgroundColor: "#eee"}}>
              <div className="row" style={{display: "flex", justifyContent: "space-betweem", margin: "5px"}}>
                <div className="col-md-6" style={{marginRight: "auto"}}>
                  <label >{I18n.t("occupancy")}</label>
                </div>
                {this.props.selected[0] == occupancy.id && this.props.selected[1] == true  
                  ?  null
                  :  <button type="button" className="no-ladda btn btn-primary btn-sm" onClick={(e) => this.props.onClickOccupancy(e, occupancy)} style={{marginLeft: "auto"}}>{I18n.t('edit')}</button>
                }  
              </div>
              <hr />
              <div className="row">   
                <br />
                {this.props.selected[0] == occupancy.id && this.props.selected[1] == true 
                ?     
                  <div className="col-md-8 form-group">
                    <select name="occupancy_comparator" value={occupancy_comparator != null ? occupancy_comparator : occupancy.occupancy_comparator} onChange={(e) => this.props.onChangeOccupancyComparator(e, occupancy)} className={this.renderFieldClasses("occupancy_comparator")}>
                      <option value="less_than_or_equal_to">{I18n.t("less_than_or_equal_to")}</option>
                      <option value="greater_than_or_equal_to">{I18n.t("greater_than_or_equal_to")}</option>
                    </select>
                  </div>
                : 
                  <div style={{marginRight: "auto", paddingLeft: "10px"}}>{occupancy_comparator ? I18n.t(occupancy_comparator) : I18n.t(occupancy.occupancy_comparator)}</div>   
                }
            
                {this.renderFieldErrors("occupancy_comparator")}
                <div className="col-md-4">
                  <span>
                    {/* <div style={{backgroundColor: occupancy.color, width: '20px', height: '20px', display: 'inline-block', position: 'relative', top: '5px'}}></div> */}
                    {`  ${this.formatPercentage(occupancy.occupancy_percentage)}`}
                    <span></span>
                  </span>
                </div>
              </div>
              <div className="row" style={{paddingTop: '10px'}}>
                <div className="col-md-5">
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label>{I18n.t('amount')} <span className="ss-help help" title={I18n.t('rate_amount_helper_text')}></span></label>
                    {this.props.selected[0] == occupancy.id && this.props.selected[1] == true  
                      ?  <CurrencyInput name="amount" onChange={(e) => this.props.onChangeAmount(e, occupancy)} value={amount} className={this.renderFieldClasses('amount')} />
                      :  <div>{amount ? this.formatCurrency(amount) : null}</div>
                    }
                    {this.renderFieldErrors('amount')}
                  </div>
                </div>
                <div className="col-md-2 or-col">
                  <div className="input-group input-group-currency maxlength7">{I18n.t('or')}</div>
                </div>
                <div className="col-md-5">
                  <div className="form-group percentage-form-group">
                    <label>{I18n.t('percentage')} <span className="ss-help help" title={I18n.t('rate_percentage_helper_text')}></span></label>
                    {this.props.selected[0] == occupancy.id && this.props.selected[1] == true  
                      ?  <PercentageInput name="percentage" onChange={(e) => this.props.onChangePercentage(e, occupancy)} value={percentage} className={this.renderFieldClasses('percentage')} />
                      :  <div>{percentage ? this.formatPercentage(percentage) : null}</div>
                    }
                    {this.renderFieldErrors('percentage')}
                  </div>
                </div>
              </div>
              {this.renderRoomTypes(room_types, this.props.selected[0] == occupancy.id && this.props.selected[1] == true)}
              {this.renderRates(auto_price_rates, this.props.selected[0] == occupancy.id && this.props.selected[1] == true)}
              {this.props.selected[0] == occupancy.id && this.props.selected[1] == true
                ? this.renderClearButton(occupancy)
                : null
              }
            </div>
          </div>
        </div>
      )
    })
    return (
      <div className= "row">
        {occupancies}
      </div>
    )  
  }

  renderRoomTypes(room_type_ids, isCurrentContainerInEditMode) {
    const room_type_names = []
    // Show room types section if there are existing room types OR if this specific container is in edit mode
    if(room_type_ids.length > 0 || isCurrentContainerInEditMode) {
      if(room_type_ids.length > 0) {
        room_type_ids.map((id) => {
          this.props.all_room_types.forEach((type) => {
            if(type.id == id) {
              const room_type = type.name
              room_type_names.push(room_type)
            }
          })
        })
      }
      
      var room_type_list = room_type_names.map((name, idx) => {
        return (
          <li key={idx}>{name}</li>
        )
      })
      
      return (
        <div className="row" style={{paddingTop: '10px'}}>
          <div className="col-md-12">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t('room_types')} {isCurrentContainerInEditMode ? <a href="#" onClick={(e) => { e.preventDefault(); this.props.onSetActiveTab('room_types'); }} style={{textDecoration: 'underline', cursor: 'pointer', color: '#0066cc', fontStyle: 'italic', fontSize: '0.9em'}}>{I18n.t('see_room_types_tab_above')}</a> : null}</label>
              {room_type_names.length > 0 ? (
                <ul>
                  {room_type_list}
                </ul>
              ) : (
                <div style={{fontStyle: 'italic', color: '#666', paddingLeft: '40px'}}>{I18n.t('none')}</div>
              )}
            </div>
          </div>
        </div>
      )
    }
  }

  renderRates(auto_price_rate_ids, isCurrentContainerInEditMode) {
    const auto_price_rate_names = []
    // Show rates section if there are existing rates OR if this specific container is in edit mode
    if(auto_price_rate_ids.length > 0 || isCurrentContainerInEditMode) {
      if(auto_price_rate_ids.length > 0) {
        auto_price_rate_ids.map((id) => {
          this.props.all_rates.forEach((rate) => {
            if(rate.id == id) {
              const auto_price_rate = rate.name
              auto_price_rate_names.push(auto_price_rate)
            }
          })
        })
      }
      
      var auto_price_rate_list = auto_price_rate_names.map((name, idx) => {
        return (
          <li key={idx}>{name}</li>
        )
      })
      
      return (
        <div className="row" style={{paddingTop: '10px'}}>
          <div className="col-md-12">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t('rates')} {isCurrentContainerInEditMode ? <a href="#" onClick={(e) => { e.preventDefault(); this.props.onSetActiveTab('rates'); }} style={{textDecoration: 'underline', cursor: 'pointer', color: '#0066cc', fontStyle: 'italic', fontSize: '0.9em'}}>{I18n.t('see_rates_tab_above')}</a> : null}</label>
              {auto_price_rate_names.length > 0 ? (
                <ul>
                  {auto_price_rate_list}
                </ul>
              ) : (
                <div style={{fontStyle: 'italic', color: '#666', paddingLeft: '40px'}}>{I18n.t('none')}</div>
              )}
            </div>
          </div>
        </div>
      )
    }
  }

  renderClearButton(pace) {
    return (
      <div style={{display:"flex", justifyContent:"flex-end"}}>
        <button type="button" className="no-ladda btn btn-secondary btn-sm"onClick={(e) => this.props.onClearPriceAdjustment(e, pace)} style={{margin: "3px"}}>{I18n.t('reset')}</button>
        <button type="button" className="no-ladda btn btn-primary btn-sm" onClick={(e) => this.props.onClickOk(e, pace)} style={{margin: "3px"}}>{I18n.t('ok')}</button>
      </div>
    )
  }

  onChangeBlackout(blackoutState) {
    this.props.onChange({
      target: {
        name: "blackout",
        value: blackoutState,
      },
    });
  }

  onChangeStartDate(startDate) {
    this.props.onChangeStartDate(startDate);
  }

  onChangeEndDate(endDate) {
    this.props.onChangeEndDate(endDate);
  }

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  formatPercentage(num) {
    return parseFloat((num * 100).toFixed(2)) + "%"
  }
}

export default AutoPriceRuleBuilderGeneral;
